import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/DDBU_Logo.png'


const _withScopeId = n => (_pushScopeId("data-v-1233cf64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-header" }
const _hoisted_2 = { class: "top-header__left" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "top-header__right" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "top-bar" }
const _hoisted_7 = { class: "top-bar__left" }
const _hoisted_8 = { class: "top-bar__center" }
const _hoisted_9 = ["onClick", "onMouseover"]
const _hoisted_10 = { class: "left" }
const _hoisted_11 = ["onMouseover", "onClick"]
const _hoisted_12 = { class: "right" }
const _hoisted_13 = {
  key: 0,
  style: {"position":"absolute","top":"8px","right":"8px"}
}
const _hoisted_14 = ["src", "onClick"]
const _hoisted_15 = { style: {"margin-inline":"0.5rem","display":"flex","gap":"5px","align-items":"center","justify-content":"start","color":"#999","text-transform":"capitalize"} }
const _hoisted_16 = { style: {"font-size":"12px"} }
const _hoisted_17 = { class: "right" }
const _hoisted_18 = ["src", "onClick"]
const _hoisted_19 = { style: {"margin-inline":"0.5rem","display":"flex","gap":"5px","align-items":"center","justify-content":"start","color":"#999","text-transform":"capitalize"} }
const _hoisted_20 = { style: {"font-size":"12px"} }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 1,
  class: "dropdown second-level"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 1,
  class: "dropdown third-level"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  class: "top-bar__right",
  style: {"position":"relative"}
}
const _hoisted_27 = { ref: "openSearchRef" }
const _hoisted_28 = {
  key: 0,
  class: "search-box",
  ref: "searchRef"
}
const _hoisted_29 = { class: "search-input-wrapper" }
const _hoisted_30 = { class: "search-icon-wrapper" }
const _hoisted_31 = {
  key: 0,
  class: "search-results"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "result-item" }
const _hoisted_34 = ["src", "onClick"]
const _hoisted_35 = { class: "result-content" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "result-meta" }
const _hoisted_38 = { class: "meta-date" }
const _hoisted_39 = {
  key: 0,
  class: "meta-comments"
}
const _hoisted_40 = { class: "view-more" }
const _hoisted_41 = ["href"]
const _hoisted_42 = {
  key: 1,
  class: "no-data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_it_dropdown = _resolveComponent("it-dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTopBar(), (menu, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "top-header__item",
            key: index,
            style: {"cursor":"pointer"}
          }, [
            _createElementVNode("a", {
              onClick: ($event: any) => (_ctx.navigationRouter(menu.menu_url)),
              style: {"color":"#fff"}
            }, _toDisplayString(menu.menu_titel), 9, _hoisted_3)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialIcons, (social, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "top-header__icon",
            key: index
          }, [
            (!social.external)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: social.href
                }, {
                  default: _withCtx(() => [
                    (['contact'].includes(social.icon))
                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 0,
                          icon: ['fab', social.icon],
                          alt: social.alt,
                          style: {"width":"20px","height":"20px","color":"#fff"}
                        }, null, 8, ["icon", "alt"]))
                      : (_openBlock(), _createBlock(_component_va_icon, {
                          key: 1,
                          color: "#fff",
                          name: social.icon,
                          alt: social.alt
                        }, null, 8, ["name", "alt"]))
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: social.href,
                  target: "_blank",
                  rel: "noopener"
                }, [
                  (['contact'].includes(social.icon))
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 0,
                        icon: ['fab', social.icon],
                        alt: social.alt,
                        style: {"width":"20px","height":"20px","color":"#fff"}
                      }, null, 8, ["icon", "alt"]))
                    : (_openBlock(), _createBlock(_component_va_icon, {
                        key: 1,
                        color: "#fff",
                        name: social.icon,
                        alt: social.alt
                      }, null, 8, ["name", "alt"]))
                ], 8, _hoisted_5))
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("img", {
          class: "top-bar__logo",
          src: _imports_0,
          alt: "ddbu logo",
          width: "150",
          height: "80",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.home()))
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_va_icon, {
          name: "home",
          class: "homeBtn",
          size: "1.3em",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.home()))
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTopMenu(), (menu, index) => {
          return (_openBlock(), _createBlock(_component_it_dropdown, {
            class: "menuitem",
            key: index
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "menubutton",
                onClick: ($event: any) => (_ctx.goToMainMenu(menu)),
                onMouseover: ($event: any) => (menu.menu_titel === 'Links' ? _ctx.fetchLinksPosts(_ctx.subMenu(menu?.id)[0]) : '')
              }, [
                _createTextVNode(_toDisplayString(menu.menu_titel) + " ", 1),
                (_ctx.subMenu(menu?.id)?.length)
                  ? (_openBlock(), _createBlock(_component_va_icon, {
                      key: 0,
                      class: "arrow-icon",
                      name: "keyboard_arrow_down"
                    }))
                  : _createCommentVNode("", true),
                (menu.menu_titel === 'Discipliner')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "dropdown2",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("ul", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subMenu(menu?.id), (sub1, index1) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: index1,
                              class: _normalizeClass(["submenu-item", { 'hovered': _ctx.lastHoveredItem === sub1.menu_titel }]),
                              onMouseover: ($event: any) => (_ctx.fetchItems(sub1.menu_titel)),
                              onClick: ($event: any) => (_ctx.goToCategories(sub1.menu_titel))
                            }, _toDisplayString(sub1.menu_titel), 43, _hoisted_11))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: item.id
                          }, [
                            (index === (_ctx.filteredItems.length -1))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _createVNode(_component_va_icon, {
                                    style: _normalizeStyle(_ctx.isPrevDisabled ? 'pointer-events: none; cursor: auto;':''),
                                    onClick: _withModifiers(_ctx.prevPosts, ["prevent"]),
                                    class: "bg-black-hover",
                                    name: "chevron_left"
                                  }, null, 8, ["style", "onClick"]),
                                  _createVNode(_component_va_icon, {
                                    style: _normalizeStyle(_ctx.isNextDisabled ? 'pointer-events: none; cursor: auto;':''),
                                    onClick: _withModifiers(_ctx.nextPosts, ["prevent"]),
                                    class: "bg-black-hover",
                                    name: "chevron_right"
                                  }, null, 8, ["style", "onClick"])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("img", {
                              src: _ctx.extractImgUrl(item),
                              onClick: ($event: any) => (_ctx.viewPostById(item)),
                              alt: "img",
                              class: "post_img"
                            }, null, 8, _hoisted_14),
                            _createElementVNode("p", null, _toDisplayString(item.indlaeg_slug), 1),
                            _createElementVNode("span", _hoisted_15, [
                              _createVNode(_component_va_icon, {
                                size: "14px",
                                name: "schedule"
                              }),
                              _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.formatDate(item?.updatedAt)), 1)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : (menu.menu_titel === 'Links')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: "dropdown2 links-dropdown",
                        onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _createElementVNode("div", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.LinksfilteredItems, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.id
                            }, [
                              _createElementVNode("img", {
                                src: _ctx.extractImgUrl(item),
                                onClick: ($event: any) => (_ctx.viewPostById(item)),
                                alt: "img",
                                class: "post_img"
                              }, null, 8, _hoisted_18),
                              _createElementVNode("p", null, _toDisplayString(item.indlaeg_slug), 1),
                              _createElementVNode("p", _hoisted_19, [
                                _createVNode(_component_va_icon, {
                                  size: "14px",
                                  name: "schedule"
                                }),
                                _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.formatDate(item?.updatedAt)), 1)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : (_ctx.subMenu(menu?.id)?.length)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 3,
                          class: "dropdown",
                          onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                        }, [
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subMenu(menu?.id), (sub1, index1) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: index1,
                                class: "submenu-item",
                                onClick: (e) => {
            e.stopPropagation()
            _ctx.navigationRouter(sub1.menu_url, sub1.menu_titel)
          }
          
                              }, [
                                _createTextVNode(_toDisplayString(sub1.menu_titel) + " ", 1),
                                (_ctx.subSubMenu(sub1?.id)?.length)
                                  ? (_openBlock(), _createBlock(_component_va_icon, {
                                      key: 0,
                                      class: "arrow-icon-right",
                                      name: "chevron_right"
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.subSubMenu(sub1?.id)?.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                      _createElementVNode("ul", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subSubMenu(sub1?.id), (sub2, index2) => {
                                          return (_openBlock(), _createElementBlock("li", {
                                            key: index2,
                                            class: "submenu-item",
                                            onClick: (e) => {
                  e.stopPropagation()
                  _ctx.navigationRouter(sub2.menu_url, sub1.menu_titel, sub2.menu_titel)
                 }
                                          }, [
                                            _createTextVNode(_toDisplayString(sub2.menu_titel) + " ", 1),
                                            (_ctx.subSubSubMenu(sub2?.id)?.length)
                                              ? (_openBlock(), _createBlock(_component_va_icon, {
                                                  key: 0,
                                                  class: "arrow-icon-right",
                                                  name: "chevron_right"
                                                }))
                                              : _createCommentVNode("", true),
                                            (_ctx.subSubSubMenu(sub2?.id)?.length)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                                  _createElementVNode("ul", null, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subSubSubMenu(sub2?.id), (sub3, index3) => {
                                                      return (_openBlock(), _createElementBlock("li", {
                                                        key: index3,
                                                        class: "submenu-item",
                                                        onClick: (e) => {
                        e.stopPropagation()
                        _ctx.navigationRouter(sub3.menu_url, sub1.menu_titel, sub2.menu_titel, sub3.menu_titel)
                      }
                                                      }, _toDisplayString(sub3.menu_titel), 9, _hoisted_25))
                                                    }), 128))
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true)
                                          ], 8, _hoisted_23))
                                        }), 128))
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 8, _hoisted_21))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
              ], 40, _hoisted_9)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_va_icon, {
            name: "search",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openSearchBox())),
            color: "#fff"
          })
        ], 512),
        (_ctx.isSearchBoxOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("form", {
                role: "search",
                "aria-label": "Site Search",
                onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_29, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchQuery) = $event)),
                    type: "search",
                    id: "search",
                    name: "search",
                    placeholder: "Search here...",
                    class: "search-input",
                    onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.debouncedSearch && _ctx.debouncedSearch(...args)))
                  }, null, 544), [
                    [_vModelText, _ctx.searchQuery]
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    (_ctx.isLoading)
                      ? (_openBlock(), _createBlock(_component_va_icon, {
                          key: 0,
                          name: "loop",
                          spin: "",
                          class: "search-icon loading"
                        }))
                      : (_openBlock(), _createBlock(_component_va_icon, {
                          key: 1,
                          name: "search",
                          class: "search-icon",
                          onClick: _ctx.onSearch
                        }, null, 8, ["onClick"]))
                  ])
                ])
              ], 32),
              (_ctx.searchQuery.trim() && _ctx.resultsView)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    (_ctx.results.length > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results.slice(0,4), (item, i) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: i,
                                onClick: ($event: any) => (_ctx.selectResult(item))
                              }, [
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("img", {
                                    src: _ctx.extractImgUrl(item),
                                    onClick: ($event: any) => (_ctx.viewPostById(item)),
                                    alt: "img",
                                    class: "post_img"
                                  }, null, 8, _hoisted_34),
                                  _createElementVNode("div", _hoisted_35, [
                                    _createElementVNode("p", {
                                      onClick: ($event: any) => (_ctx.viewPostById(item)),
                                      class: "result-title red-hover"
                                    }, _toDisplayString(item.indlaeg_slug), 9, _hoisted_36),
                                    _createElementVNode("div", _hoisted_37, [
                                      _createElementVNode("span", _hoisted_38, [
                                        _createVNode(_component_va_icon, {
                                          size: "14px",
                                          name: "schedule"
                                        }),
                                        _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(item?.updatedAt)), 1)
                                      ]),
                                      (item.comments !== undefined)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                                            _createVNode(_component_va_icon, {
                                              size: "14px",
                                              name: "chat_bubble_outline"
                                            }),
                                            _createElementVNode("span", null, _toDisplayString(item.comments || 0), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ])
                              ], 8, _hoisted_32))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("a", {
                              href: '/search/' + _ctx.searchQuery,
                              class: "view-more-link"
                            }, " View More Search Results ", 8, _hoisted_41)
                          ])
                        ], 64))
                      : (_openBlock(), _createElementBlock("div", _hoisted_42, "No data found"))
                  ]))
                : _createCommentVNode("", true)
            ], 512))
          : _createCommentVNode("", true),
        (_ctx.userLoggedIn())
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "loggedInUser",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.toMemberPortal()))
            }, [
              _createVNode(_component_va_icon, {
                name: "account_circle",
                class: "ml-1"
              }),
              _createElementVNode("span", null, "Hej " + _toDisplayString(_ctx.getUserName()), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.userLoggedIn())
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              type: "button",
              class: "login-button loginBtn",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.userLogout()))
            }, " Logout "))
          : (_openBlock(), _createElementBlock("button", {
              key: 3,
              type: "button",
              class: "login-button loginBtn",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.login()))
            }, " Login "))
      ])
    ])
  ], 64))
}